import * as React from "react";
const SvgHome = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={40} height={40} fill="none" {...props}>
    <path
      stroke="#191919"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.6}
      d="M17 29v-7.4c0-.56 0-.84.109-1.054a1 1 0 0 1 .437-.437C17.76 20 18.04 20 18.6 20h2.8c.56 0 .84 0 1.054.109a1 1 0 0 1 .437.437C23 20.76 23 21.04 23 21.6V29m-3.982-18.236-6.783 5.275c-.453.353-.68.53-.843.75a2 2 0 0 0-.318.65c-.074.265-.074.552-.074 1.126V25.8c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C12.52 29 13.08 29 14.2 29h11.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C29 27.48 29 26.92 29 25.8v-7.235c0-.574 0-.861-.074-1.126a2 2 0 0 0-.318-.65c-.163-.22-.39-.397-.843-.75l-6.783-5.275c-.351-.273-.527-.41-.72-.462a1 1 0 0 0-.523 0c-.194.052-.37.189-.721.462"
    />
  </svg>
);
export default SvgHome;
